import $ from 'jquery';

/**
 * Functions to show/hide conditional content based on user selections
 * Currently supports only checkbox and radio
 *
 * Markup example:
 * <input class="show-form-extra" aria-controls="form-extra-demo" type="checkbox" />
 * <div class="form-extra--hidden" id="form-extra-demo">
 *  <input type="text" >
 *  <input type="text" class="form-extra__field--required">
 * </div>
 */

/**
 * Attach handler for input
 */
function attachHandler() {
  const input = $(this);
  const extras = $('#' + input.attr('aria-controls'));

  if(input.attr('type') === 'checkbox') {
    input.change(function() {
      input.is(":checked") ? openElement(extras) : closeElement(extras);
    });
  } else if (input.attr('type') === 'radio') {
    const siblings = $('input[name="' + input.attr('name') + '"]');
    siblings.change(function() {
      input.is(":checked") ? openElement(extras) : closeElement(extras);
    });
  }
}

/**
* Open element and set field requirements
* @param {jQuery} $element - container for extra content
*/
function openElement($element){
  $element.removeClass('form-conditional--hidden');
  $element.find('.form-conditional__field--required').prop('required', true);
}

/**
* Close element and remove field requirements
* @param {jQuery} $element - container for extra content
*/
function closeElement($element){
  $element.addClass('form-conditional--hidden');
  $element.find('.form-conditional__field--required').prop('required', false);
}

function init() {
  const toggleInputs = $('.show-form-conditional');
  toggleInputs.each(attachHandler);
}

export default { init };
export { init };
